<template>
  <v-content>
    <v-container
      class="ma-0"
      fluid
    >
      <pageTitle>
        Edit Profile
      </pageTitle>
      <v-form
        ref="profileForm"
      >
        <v-row
          class="ma-0"
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <template
              v-if="!profile.isEditPhoto"
            >
              <svg
                @click="editPhoto"
                v-if="!profile.photoUrl"
                width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="70" cy="70" r="68" fill="white" stroke="#EAE9E9" stroke-width="4"/>
                <circle cx="70" cy="70" r="60" fill="#EAE9E9"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M69.96 30C47.88 30 30 47.92 30 70C30 92.08 47.88 110 69.96 110C92.08 110 110 92.08 110 70C110 47.92 92.08 30 69.96 30ZM70 102C52.32 102 38 87.68 38 70C38 52.32 52.32 38 70 38C87.68 38 102 52.32 102 70C102 87.68 87.68 102 70 102ZM90 60C90 63.32 87.32 66 84 66C80.68 66 78 63.32 78 60C78 56.68 80.68 54 84 54C87.32 54 90 56.68 90 60ZM56 66C59.32 66 62 63.32 62 60C62 56.68 59.32 54 56 54C52.68 54 50 56.68 50 60C50 63.32 52.68 66 56 66ZM89.0004 81C85.2004 87.56 78.1204 92 70.0004 92C61.8804 92 54.8004 87.56 51.0004 81C50.2404 79.68 51.2404 78 52.7604 78H87.2404C88.8004 78 89.7604 79.68 89.0004 81Z" fill="#929191"/>
              </svg>
              <avatar
                v-else
                :photoUrl="profile.photoUrl"
                :name="profile.nickname"
                size="140"
                @click="editPhoto"
              ></avatar>
            </template>
            <croppa
              ref="facePhoto"
              :class="profile.isEditPhoto ? 'd-inline-block' : 'd-none'"
              style="inline-height: 0;"
              :width="150"
              :height="150"
              :file-size-limit="10000000"
              :prevent-white-space="true"
              placeholder-color="black"
              :placeholder-font-size="12"
              placeholder="Upload your face photo"
              :show-remove-button="true"
              :remove-button-size="30"
              v-model="profile.croppa"
              @file-choose="profile.isEditPhoto = true"
              @image-remove="handleImageRemove"
            ></croppa>
            <div
              class="text-center"
            >
              <svg
                style="cursor:pointer"
                v-if="profile.isEditPhoto"
                @click="profile.croppa.rotate()"
                width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="icon/image/crop_rotate_24px" fill-rule="evenodd" clip-rule="evenodd" d="M6.33943 1.39203C8.00943 0.502117 10.1694 -0.117821 12.6094 0.0321644L8.79943 3.84178L7.46943 2.51192C4.37943 3.97177 2.12943 6.88148 1.57943 10.3711C1.51943 10.7811 1.13943 11.0611 0.719425 10.9911C0.309425 10.9311 0.0294247 10.5411 0.0994263 10.1312C0.699425 6.33153 3.05943 3.13185 6.33943 1.39203ZM14.9994 15.9906H4.99943C4.44942 15.9906 3.99943 16.4405 3.99943 16.9905C3.99943 17.5404 4.44942 17.9904 4.99943 17.9904H5.99943V18.9903C5.99943 19.5402 6.44942 19.9902 6.99943 19.9902C7.54943 19.9902 7.99942 19.5402 7.99942 18.9903V17.9904H15.9994C17.0994 17.9904 17.9994 17.0905 17.9994 15.9906V7.99137H18.9994C19.5494 7.99137 19.9994 7.54141 19.9994 6.99147C19.9994 6.44152 19.5494 5.99157 18.9994 5.99157H17.9994V4.99167C17.9994 4.44172 17.5494 3.99177 16.9994 3.99177C16.4494 3.99177 15.9994 4.44172 15.9994 4.99167V14.9907C15.9994 15.5406 15.5494 15.9906 14.9994 15.9906ZM7.99942 13.9908V8.99127C7.99942 8.44132 8.44942 7.99137 8.99942 7.99137H13.9994V5.99157H7.99942C6.89943 5.99157 5.99942 6.89148 5.99942 7.99137V13.9908H7.99942ZM22.4194 13.6208C21.8694 17.1105 19.6194 20.0202 16.5294 21.48L15.1994 20.1502L11.3894 23.9698C13.8294 24.1198 15.9894 23.4998 17.6594 22.6099C20.9394 20.8701 23.2994 17.6704 23.8994 13.8608C23.9694 13.4508 23.6894 13.0609 23.2794 13.0009C22.8594 12.9309 22.4794 13.2108 22.4194 13.6208Z" fill="#929191"/>
              </svg>
            </div>
          </v-col>
        </v-row>
        <blockContent>
          <v-text-field
            label="Emoji to describe your passion🧡 ※"
            :rules="[rules.required]"
            ref="passionEmoji"
            v-model="profile.passionEmoji"
            class="passion-emoji"
            readonly
            @click="openEmojiPicker"
          ></v-text-field>
        </blockContent>
        <v-dialog
          transition="scroll-y-reverse-transition"
          v-model="showEmojiPicker"
          class="ma-0"
          content-class="emoji-picker-dialog"
        >
          <v-text-field
            rounded
            filled
            dense
            hide-details
            height="32"
            background-color="lightGray1"
            :rules="[rules.required]"
            ref="passionEmoji"
            v-model="profile.passionEmoji"
            class="passion-emoji pa-3"
          >
            <template v-slot:append-outer>
              <v-btn
                depressed
                rounded
                color="primary"
                height="32"
                class="text-capitalize fz16 font-weight-bold"
                @click="showEmojiPicker = false">
                Done
              </v-btn>
            </template>
          </v-text-field>
          <VEmojiPicker @select="(emoji) => {
            if (!profile.passionEmoji) {
              profile.passionEmoji = emoji.data
            } else {
              profile.passionEmoji += emoji.data
            }
          }" />
        </v-dialog>
        <blockTitle>
          Private Information &#x1f511;
          <v-icon
            @click="showPrivateInfoHint"
          >
            mdi-help-circle-outline
          </v-icon>
        </blockTitle>
        <blockContent>
          <v-text-field
            label="First name ※"
            :rules="[rules.required]"
            ref="firstName"
            v-model="profile.firstName"
          ></v-text-field>
          <v-text-field
            label="Last name ※"
            :rules="[rules.required]"
            ref="lastName"
            v-model="profile.lastName"
          ></v-text-field>
          <v-text-field
            label="Email Address📧※"
            type="email"
            :rules="[rules.required]"
            ref="email"
            v-model="profile.email"
          ></v-text-field>
          <v-menu
            class="d-inline"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transaction="scale-transition"
            offset-y
            min-width="290px"
          >
            <template
              v-slot:activator="{ on }"
            >
              <v-text-field
                label="Birthday🎂※"
                readonly
                v-on="on"
                :rules="[rules.required]"
                ref="birthday"
                v-model="profile.birthday"
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="profile.birthday"
              :max="new Date().toISOString().substr(0, 10)"
              min="1901-01-01"
              @change="save"
            ></v-date-picker>
          </v-menu>
          <v-text-field
            v-if="!user.phoneNumber"
            label="Mobile📱(Country code)"
            v-model="profile.phoneNumberCountryCode"
            readonly
            @click="clickPhoneNumberCountryCode"
            @keyup="clickPhoneNumberCountryCode"
          ></v-text-field>
          <v-text-field
            label="Mobile📱"
            :readonly="!(!user.phoneNumber)"
            v-model="profile.phoneNumber"
          ></v-text-field>
        </blockContent>
        <blockTitle>
          Public Information&#x1f310;
          <v-icon
            @click="showPublicInfoHint"
          >
            mdi-help-circle-outline
          </v-icon>
        </blockTitle>
        <blockContent>
          <v-text-field
            label="Nickname ※"
            :rules="[rules.required]"
            ref="nickname"
            v-model="profile.nickname"
          ></v-text-field>
          <v-text-field
            label="Live in ※"
            readonly
            @click="clickWhereLive"
            @keyup="clickWhereLive"
            :rules="[rules.required]"
            ref="whereLive"
            v-model="whereLive"
          ></v-text-field>
        </blockContent>
        <blockTitle
          class="optional-info"
        >
          Optional Information
        </blockTitle>
        <blockContent>
          <v-text-field
            label="Paikeout Area 1"
            placeholder="Paikeout Area 1 (Optional)"
            v-model="paikeoutArea1"
            readonly
            @click="clickPaikeoutArea(1)"
            @keyup="clickPaikeoutArea(1)"
            append-outer-icon="mdi-help-circle-outline"
            @click:append-outer="showPaikeoutAreaHint"
          ></v-text-field>
          <v-text-field
            label="Paikeout Area 2"
            placeholder="Paikeout Area 2 (Optional)"
            v-model="paikeoutArea2"
            readonly
            @click="clickPaikeoutArea(2)"
            @keyup="clickPaikeoutArea(2)"
          ></v-text-field>
          <v-text-field
            label="Paikeout Area 3"
            placeholder="Paikeout Area 3 (Optional)"
            v-model="paikeoutArea3"
            readonly
            @click="clickPaikeoutArea(3)"
            @keyup="clickPaikeoutArea(3)"
          ></v-text-field>
          <v-textarea
            label="Can speak languages"
            placeholder="Can speak languages (Optional)"
            :value="profile.canSpeakLanguages.join(', ')"
            readonly
            auto-grow
            rows="1"
            @click="clickCanSpeakLanguage"
            @keyup="clickCanSpeakLanguage"
          ></v-textarea>
          <v-textarea
            label="Languages under study"
            placeholder="Languages under study (Optional)"
            :value="profile.languagesUnderStudy.join(', ')"
            readonly
            auto-grow
            rows="1"
            @click="clickLanguagesUnderStudy"
            @keyup="clickLanguagesUnderStudy"
          ></v-textarea>
          <v-select
            label="Gender"
            placeholder="Gender (Optional)"
            v-model="profile.gender"
            :items="genderList"
          ></v-select>
          <v-textarea
            label="Characteristics"
            placeholder="Characteristics (Optional)"
            :value="profile.character.join(', ')"
            readonly
            auto-grow
            rows="1"
            @click="clickCharacter"
            @keyup="clickCharacter"
          ></v-textarea>
          <v-text-field
            label="School"
            placeholder="School (Optional)"
            v-model="profile.school"
          ></v-text-field>
          <v-textarea
            label="About me"
            placeholder="About me (Optional)"
            hint="Tell us a little bit about yourself, so your future friends can get to know you."
            persistent-hint
            readonly
            auto-grow
            rows="5"
            v-model="profile.comment"
            @click="getFocusAboutMe"
            @keyup="getFocusAboutMe"
          ></v-textarea>
        </blockContent>
      </v-form>
      <blockContent>
        <v-btn
          dark
          block
          color="#FF5500"
          style="border-radius: 8px"
          elevation="0"
          class="text-capitalize fz18 font-weight-bold"
          :disabled="process"
          :loading="process"
          @click.stop="doUpdate"
        >
          Done
        </v-btn>
      </blockContent>
      <blockContent
        v-if="isAdmin"
      >
        <v-btn
          @click.stop="$router.push('/rbabpgbxbn')"
        >
          <v-icon>mdi-door-closed-lock</v-icon>
        </v-btn>
      </blockContent>

      <selectCountry
        ref="selectCountry"
        @change="changeCountry"
      ></selectCountry>

      <selectArea
        ref="selectArea"
        @change="changeArea"
      ></selectArea>

      <selectFromTheList
        ref="selectCanSpeakLanguages"
        title="Can speak Languages"
        listName="languageList"
        v-model="profile.canSpeakLanguages"
      ></selectFromTheList>

      <selectFromTheList
        ref="selectLanguagesUnderStudy"
        title="Languages under study"
        listName="languageList"
        v-model="profile.languagesUnderStudy"
      ></selectFromTheList>

      <selectFromTheList
        ref="selectCharacter"
        title="Characteristics"
        listName="characterList"
        v-model="profile.character"
      ></selectFromTheList>

      <editComment
        ref="editComment"
        v-model="profile.comment"
      ></editComment>

      <v-snackbar
        v-model="snackbar.display"
        :timeout="10000"
      >
        {{ snackbar.text }}
        <v-btn
          text
          @click="snackbar.display = false"
        >Close</v-btn>
      </v-snackbar>

      <messageBox
        ref="msgBox"
      ></messageBox>

      <v-dialog
        persistent
        v-model="dialogConfirm"
        width="300"
      >
        <v-card>
          <v-card-title>
            Fill out your profile✏️
          </v-card-title>
          <v-card-text>
            Let's fill out all the items to help your future friends get to know you better✏️
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="$router.push(nextRoute)"
            >
              SKIP
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="dialogConfirm = false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <bottomNavigation
        activeNav="myProfile"
        :changeRoute="false"
        @change="changeNavigation"
      ></bottomNavigation>

    </v-container>
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import firebase from "firebase/app"
import "firebase/firestore"
import VEmojiPicker from 'v-emoji-picker'
import MessageBox from '@/components/MessageBox'
import Avatar from '@/components/Like/Avatar'
import BottomNavigation from '@/components/Like/BottomNavigation'
import EditComment from '@/components/Like/EditComment'
import service from '@/plugins/service'
import SelectArea from '@/components/Like/SelectArea'
import SelectCountry from '@/components/Like/SelectCountry'
import SelectFromTheList from '@/components/Like/SelectFromTheList'
import pageTitle from '@/components/Like/PageTitle'
import blockTitle from '@/components/Like/BlockTitle'
import blockContent from '@/components/Like/BlockContent'

export default {
  components: {
    VEmojiPicker,
    Avatar,
    BottomNavigation,
    SelectArea,
    SelectCountry,
    SelectFromTheList,
    EditComment,
    MessageBox,
    pageTitle,
    blockTitle,
    blockContent,
  },
  computed: {
    whereLive() {
      return this.formatArea(this.profile.whereLive)
    },
    paikeoutArea1() {
      return this.formatArea(this.profile.paikeoutArea1)
    },
    paikeoutArea2() {
      return this.formatArea(this.profile.paikeoutArea2)
    },
    paikeoutArea3() {
      return this.formatArea(this.profile.paikeoutArea3)
    },
  },
  data: () => ({
    user: {},
    isAdmin: false,
    fromName: '',
    helloDialog: false,
    process: false,
    snackbar: {
      display: false,
      text: '',
    },
    date: null,
    menu: false,
    nextRoute: '',
    dialogConfirm: false,
    profile: {
      uid: '',
      passionEmoji: '',
      firstName: '',
      lastName: '',
      email: '',
      birthday: '',
      phoneNumber: '',
      phoneNumberCountryCode: '',
      datePicker: '',
      fbEmail: '',
      nickname: '',
      photoUrl: '',
      thumbnailUrl: '',
      isEditPhoto: false,
      croppa: {},
      paikeoutArea: [],
      whereLive: {
        countryCode: '',
        regionCode: '',
        cityId: '',
        country: '',
        region: '',
        city: '',
        latitude: '',
        longitude: '',
      },
      paikeoutArea1: {
        countryCode: '',
        regionCode: '',
        cityId: '',
        country: '',
        region: '',
        city: '',
        latitude: '',
        longitude: '',
      },
      paikeoutArea2: {
        countryCode: '',
        regionCode: '',
        cityId: '',
        country: '',
        region: '',
        city: '',
        latitude: '',
        longitude: '',
      },
      paikeoutArea3: {
        countryCode: '',
        regionCode: '',
        cityId: '',
        country: '',
        region: '',
        city: '',
        latitude: '',
        longitude: '',
      },
      gender: '',
      character: [],
      canSpeakLanguages: [],
      languagesUnderStudy: [],
      school: '',
      comment: '',
    },
    target: '',
    genderList: [
      { value: 'Female', text: 'Female', },
      { value: 'Male', text: 'Male', },
      { value: 'Other', text: 'Other', },
    ],
    rules: {
      required: value => (!!value && value.length > 0) || 'Required.',
    },
    initialImage: require('@/assets/images/shots/upload-face-photo.png'),
    showEmojiPicker: false
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },
  async mounted() {
    try {
      this.user = await service.authCheck()
    } catch (e) {
      this.$router.replace('/signIn/MyProfile')
      return
    }
    // Topページから遷移してきたときはようこそを表示
    if (this.fromTop()) {
      this.$refs.msgBox.show(
        'Tips✨',
        'Complete your profile so that your future friends can get to know you✏️',
        'OK',
      )
      this.setLastRoute('/myProfile')
    }
    const profile = this.profile
    profile.uid = this.user.uid

    const data = await service.getMyProfile(profile.uid)
    if (data) {
      // 既存プロファイル有り
      profile.nickname = data.nickname
      profile.passionEmoji = !data.passionEmoji ? '' : data.passionEmoji
      profile.photoUrl =  data.photoUrl
      profile.thumbnailUrl =  data.thumbnailUrl
      profile.whereLive = data.whereLive
      if (Array.isArray(data.paikeoutArea)) {
        profile.paikeoutArea = data.paikeoutArea
        if (data.paikeoutArea.length > 0) {
          profile.paikeoutArea1 = data.paikeoutArea[0]
        }
        if (data.paikeoutArea.length > 1) {
          profile.paikeoutArea2 = data.paikeoutArea[1]
        }
        if (data.paikeoutArea.length > 2) {
          profile.paikeoutArea3 = data.paikeoutArea[2]
        }
      } else {
        profile.paikeoutArea = []
      }
      profile.canSpeakLanguages = data.canSpeakLanguages
      if (! Array.isArray(profile.canSpeakLanguages)) {
        profile.canSpeakLanguages = []
      }
      profile.languagesUnderStudy = data.languagesUnderStudy
      if (! Array.isArray(profile.languagesUnderStudy)) {
        profile.languagesUnderStudy = []
      }
      profile.gender =  data.gender
      profile.character = data.character
      if (! Array.isArray(profile.character)) {
        profile.character = []
      }
      profile.school = data.school
      profile.comment = data.comment
    }
    // users private
    const db = firebase.firestore()
    const docPrivate = await db.collection('users_private').doc(profile.uid).get()
    const dataPrivate = docPrivate.data()
    if (dataPrivate) {
      // 既存プライベート情報あり
      profile.firstName =  dataPrivate.firstName
      profile.lastName = dataPrivate.lastName
      profile.email = dataPrivate.email
      profile.birthday = dataPrivate.birthday
      profile.phoneNumber = dataPrivate.phoneNumber
      profile.phoneNumberCountryCode = dataPrivate.phoneNumberCountryCode
    }
    // photoUrl補正
    if (
      !profile.photoUrl || profile.photoUrl.startsWith('https://graph.facebook.com/')
    ) {
      if (this.user.providerData[0].providerId == "facebook.com") {
        // facebookのイメージはサーバに保存してから表示する。
        const res = await service.getFacebookPhoto(this.user.uid, this.user.providerData[0].uid)
        profile.photoUrl = res.res.photoUrl
        profile.thumbnailUrl = res.res.thumbnailUrl
      }
    }
    // Email補正
    if (!profile.email && !(!this.user.email)) {
      profile.email = this.user.email
    }
    // PhoneNumber補正
    if (this.user.phoneNumber) {
      profile.phoneNumber = this.user.phoneNumber
    }
    if (Array.isArray(this.user.providerData) && this.user.providerData.length > 0) {
      const providerData = this.user.providerData[0]
      // Firstname, Lastname補正
      if (!!providerData.displayName && !profile.firstName && !profile.lastName) {
        profile.firstName = providerData.displayName
        profile.lastName = providerData.displayName
      }
    }
    // 管理者チェック
    const json = await service.getPassions({
      uid: this.user.uid,
      target: 'name',
    })
    this.isAdmin = !!json.key
  },
  methods: {
    ...mapGetters('storage', [
      'fromTop',
      'isLocal',
      'isSignIn',
      'getNextRoute',
    ]),
    ...mapActions('storage', [
      'setLastRoute',
      'clearNextRoute',
      'clearLastRoute',
    ]),
    openEmojiPicker() {
      this.showEmojiPicker = true;
      this.$nextTick(() => {
        this.$refs.passionEmoji.blur()
      })
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    async doUpdate() {
      // VuetifyによるValidation
      if (!this.$refs.profileForm.validate()) {
        this.$refs.msgBox.show(
          'Oops!',
          'Make sure all the required items are filled out🙏',
          'OK',
        )
        const requireds = [
          'passionEmoji',
          'firstName',
          'lastName',
          'email',
          'birthday',
          'nickname',
          'whereLive',
        ]
        let firstElement = ''
        requireds.forEach(elementName => {
          if (!firstElement && !this.profile[elementName]) {
            firstElement = elementName
          }
        })
        // 未入力の項目にスクロール
        if (firstElement) {
          this.$vuetify.goTo(this.$refs[firstElement])
          return
        }
        if (!this.profile.whereLive.cityId) {
          // 未入力の項目にスクロール
          this.$vuetify.goTo(this.$refs.whereLive)
        }
        return
      }
      // 写真は必須
      const profile = this.profile
      if (
        (!profile.photoUrl && !profile.isEditPhoto) ||
        (profile.isEditPhoto && (!profile.croppa || !profile.croppa.hasImage()))
      ) {
        this.$refs.msgBox.show(
          'Oops!',
          'Upload your face photo',
          'OK',
        )
        this.$vuetify.goTo(this.$refs.facePhoto)
        return
      }
      // 年齢制限
      const age = service.getAge(profile.birthday)
      if (age < 18) {
        this.$refs.msgBox.show(
          'Oops!',
          `Unfortunately, persons under the age of 18 are not allowed to use Paike by the terms of service😢<br />
We look forward to welcoming you when you turn 18😊`,
          'OK',
        )
        return
      }
      // プロフィール写真の更新
      if (profile.isEditPhoto && profile.croppa && profile.croppa.hasImage()) {
        const uid = profile.uid
        const blob = await profile.croppa.promisedBlob()
        const result = await service.uploadProfilePhoto(uid, blob)
        profile.photoUrl = result.res.photoUrl
        profile.thumbnailUrl = result.res.thumbnailUrl
        profile.isEditPhoto = false
      }
      try {
        this.process = true
        // 公開情報の登録
        service.log('start api')
        const res = await service.setProfile({
          ...profile,
          authProvider: !this.user.phoneNumber ? 'Facebook' : 'PhoneNumber',
        })
        // 非公開情報の登録
        service.log('start users private')
        const privateData = {
          firstName: profile.firstName,
          lastName: profile.lastName,
          email: profile.email,
          birthday: profile.birthday,
          phoneNumberCountryCode: !profile.phoneNumberCountryCode ? '' : profile.phoneNumberCountryCode,
          phoneNumber: !profile.phoneNumber ? '' : profile.phoneNumber,
        }
        if (this.user.phoneNumber) {
          privateData.authPhoneNumber = this.user.phoneNumber
        }
        if (this.user.email) {
          privateData.authEmail = this.user.email
          privateData.authPhotoUrl = this.user.photoURL
          privateData.authDisplayName = this.user.displayName
        }
        // ログインプロバイダー別情報の蓄積
        if (Array.isArray(this.user.providerData) && this.user.providerData.length > 0) {
          const providerData = this.user.providerData[0]
          privateData.authDisplayName = providerData.displayName
          if (!privateData.authDisplayName) {
            privateData.authDisplayName = ''
          }
          privateData.authProviderId = providerData.providerId
          privateData.authUid = providerData.uid
        }
        const db = firebase.firestore()
        await db.collection('users_private').doc(profile.uid).set(privateData, { merge: true })
        const nextRoute = this.getNextRoute()
        if (!!nextRoute) {
          // 次のrouteが決められている場合はそちらへ
          this.clearNextRoute()
          this.$router.push(nextRoute)
        } else if (this.isLocal()) {
          // Localから遷移した場合で
          // Favがない場合は、ダイアログを表示する。
          // ひとつ好きを登録しよう。
          const json = await service.getUserLikes(this.user.uid)
          if (json.res.length <= 0) {
            this.$refs.msgBox.show(
              `Let's share your passion!`,
              'Add your passion shot🧡(This is what you will share with other paikers to find a mutual passion&like!)',
              'OK',
              () => {
                this.$router.push('/post/new')
              }
            )
          } else {
            this.changeNavigation('/profile')
          }
        } else {
          this.changeNavigation('/profile')
        }
      } catch (e) {
        service.log(e)
        this.snackbar.text = 'Updated failed.'
        this.snackbar.display = true
      } finally {
        this.process = false
      }
    },
    clickPhoneNumberCountryCode() {
      this.$refs.selectCountry.show('Mobile📱(Country code)')
    },
    changeCountry(item) {
      this.profile.phoneNumberCountryCode = item.text
    },
    clickWhereLive() {
      this.target = 'LiveIn'
      this.$refs.selectArea.show('Where live?')
    },
    clickPaikeoutArea(no) {
      this.target = `P${no}`
      this.$refs.selectArea.show('Paikeout Area?')
    },
    changeArea(item) {
      if (this.target == 'LiveIn') {
        this.profile.whereLive = item
      } else if (this.target == 'P1') {
        this.profile.paikeoutArea1 = item
      } else if (this.target == 'P2') {
        this.profile.paikeoutArea2 = item
      } else if (this.target == 'P3') {
        this.profile.paikeoutArea3 = item
      }
    },
    formatArea(item) {
      if (!item) {
        return ''
      }
      if (!item.country) {
        return ''
      }
      return `${item.city}, ${item.region}, ${item.country}`
    },
    editPhoto() {
      this.profile.croppa.chooseFile()
    },
    handleImageRemove() {
      this.profile.isEditPhoto = false
    },
    getFocusAboutMe() {
      this.$refs.editComment.show('aboutMe')
    },
    clickCanSpeakLanguage() {
      this.$refs.selectCanSpeakLanguages.show()
    },
    clickLanguagesUnderStudy() {
      this.$refs.selectLanguagesUnderStudy.show()
    },
    clickCharacter() {
      this.$refs.selectCharacter.show()
    },
    changeNavigation(route) {
      if (/\/sign/.test(route)) {
        this.$router.push(route)
        return
      }
      const profile = this.profile
      if (
        !profile.firstName ||
        !profile.lastName ||
        !profile.email ||
        !profile.birthday ||
        !profile.nickname ||
        !profile.whereLive ||
        !profile.passionEmoji
      ) {
        this.$refs.msgBox.show(
          'Oops!',
          'Make sure all the required items are filled out🙏',
          'OK',
        )
      } else if (
        !profile.phoneNumber ||
        profile.canSpeakLanguages.length < 1 ||
        profile.languagesUnderStudy.length < 1 ||
        !profile.gender ||
        profile.character.length < 1 ||
        !profile.comment
      ) {
        this.nextRoute = route
        this.dialogConfirm = true
      } else {
        this.$router.push(route)
      }
    },
    showPrivateInfoHint() {
      this.$refs.msgBox.show(
        'Private Information 🔑',
        'Not visible to the public.',
        'OK',
      )
    },
    showPublicInfoHint() {
      this.$refs.msgBox.show(
        'Public Information🌐',
        'Visible to the public.',
        'OK',
      )
    },
    showPaikeoutAreaHint() {
      this.$refs.msgBox.show(
        'Paikeout Area',
        'This is a place where you usually hang out or where you would like to hang out with travelers (other than where you live).',
        'OK',
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.croppa-container
  background-color #FAFAFA
  border-radius 5px
  border 2px solid gray

.optional-info
  color #6f6b69 !important

::placeholder
  color red
  opacity 0.2

>>> .emoji-picker-dialog
  margin 0 !important
  width 100%
  position absolute
  bottom 0

  .v-input
    background #FAFAFA
    border-radius unset
    &__slot
      min-height 32px !important
      input
        margin-top 0
    &__append-outer
      margin-top 0

  #EmojiPicker
    width 100%
</style>
